// Different FWA packages bundle different router hardware revisions
// (e.g. Telia F1 vs F2 Smart Wifi Router), each with its own product id.
export const SMART_WIFI_ROUTER_PRODUCT_IDS = [1974, 2118];
